import axios from 'axios';
import { toast } from 'sonner';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:5000',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Request interceptor to add auth token and store-id
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('sq_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Add Store-ID header if available (case-sensitive as expected by server)
    const storeId = localStorage.getItem('sq_current_store');
    if (storeId) {
      config.headers['Store-ID'] = storeId;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = error.response?.data?.message || 'An error occurred';
    
    // Handle authentication errors
    if (error.response?.status === 401) {
      // Only remove token, don't redirect automatically
      localStorage.removeItem('sq_token');
      
      // Don't automatically redirect - let the auth context handle this
      // The automatic redirect was causing issues with auth flow
      
      // Only show toast for 401 errors during regular requests, not auth checks
      const isAuthCheck = error.config.url?.includes('/auth/me');
      if (!isAuthCheck) {
        toast.error('Session expired. Please login again.');
      }
    }
    // Handle CORS errors
    else if (error.message === 'Network Error') {
      console.error('CORS or network error detected');
      toast.error('Network error. Please check your connection or contact support.');
    }
    // Handle 500+ server errors
    else if (error.response?.status >= 500) {
      console.error('Server error:', message);
      toast.error('Server error. Please try again later.');
    }
    // Don't automatically show toasts for 400 errors - let components handle them
    else {
      console.error('API Error:', message);
    }
    
    return Promise.reject(error);
  }
);

export default api; 